import React, { PureComponent } from 'react';
import { Animated, Easing, ViewStyle } from 'react-native';

import { Indicator, IndicatorProps, IndicatorRenderOptions } from './indicator';
import { Colors } from 'theme/colors';

import { styles } from './styles';

const HALF_SCALE = 0.5;
const ONE_HALF_SCALE = 1.5;

const LINEAR_STEP_2 = 1.36;
const LINEAR_STEP_3 = 1.56;
const LINEAR_STEP_4 = 1.06;

export class DotIndicator extends PureComponent<Props> {
  public static defaultProps = {
    animationEasing: Easing.inOut(Easing.ease),
    color: Colors.black,
    count: 4,
    size: 16,
  };

  public constructor(props: Props) {
    super(props);

    this.renderComponent = this.renderComponent.bind(this);
  }

  public render() {
    const { style, ...props } = this.props;

    return (
      <Indicator
        style={[styles.container, style] as ViewStyle}
        renderComponent={this.renderComponent}
        {...props}
      />
    );
  }

  private renderComponent({ index, count, progress }: IndicatorRenderOptions) {
    const { size, color: backgroundColor } = this.props;

    const style = {
      backgroundColor,
      borderRadius: size / 2,
      height: size,
      margin: size / 2,
      transform: [
        {
          scale: progress.interpolate({
            inputRange: [
              0,
              (index + HALF_SCALE) / (count + 1),
              (index + 1) / (count + 1),
              (index + ONE_HALF_SCALE) / (count + 1),
              1,
            ],
            outputRange: [1, LINEAR_STEP_2, LINEAR_STEP_3, LINEAR_STEP_4, 1],
          }),
        },
      ],
      width: size,
    };

    return <Animated.View style={style} key={index} />;
  }
}

/* Type definitions */
interface Props extends IndicatorProps {
  color: Colors;
  size: number;
}
